<script lang="ts" setup>
withDefaults(
  defineProps<{
    title?: string | null
  }>(),
  { title: null }
)
</script>

<template>
  <h1
    class="
      !mb-0 text-[28px] font-medium leading-none text-white lg:text-[44px] 2xl:leading-[1.09]
    "
  >
    {{ title }}
  </h1>
</template>
